/**
 * useLanguage — shim hook for the JTR UI kit.
 *
 * The kit ships with `import { useLanguage } from '@/lib/i18n'` which
 * is JTR-specific. NoJo Enterprise uses a URL-prefix language pattern
 * (`/en/...` and `/ja/...`) where the router passes `lang` down as a
 * prop. This shim derives the same { lang } shape by reading the
 * first segment of the URL, so the kit components work unchanged.
 */
import { useLocation } from "react-router-dom";

export function useLanguage() {
  const { pathname } = useLocation();
  const first = pathname.split("/").filter(Boolean)[0];
  const lang = first === "ja" ? "ja" : "en";
  return { lang };
}
